import { render, staticRenderFns } from "./daka_data.vue?vue&type=template&id=d30c6a50&"
import script from "./daka_data.vue?vue&type=script&lang=js&"
export * from "./daka_data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports